import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';

export default class IndexController extends Controller {
  @service auth;
  @service router;
  @service cloudAjax;
  @service websocket;
  @tracked isRefreshing = false;

  /**
   * Events sorted by date (most recent first)
   */
  get sortedEvents() {
    const events = this.model?.events || [];
    return [...events].sort((a, b) => {
      // Sort by date descending (most recent first)
      // Handle null/undefined dates by putting them at the end
      if (!a.date && !b.date) return 0;
      if (!a.date) return 1;
      if (!b.date) return -1;
      return new Date(b.date) - new Date(a.date);
    });
  }

  get lastUpdatedTime() {
    return this.model?.lastUpdated?.toLocaleTimeString() || 'Never';
  }

  get websocketMessages() {
    return this.websocket.messages;
  }

  get websocketStatus() {
    return this.websocket.connectionStatus;
  }

  get isWebsocketConnected() {
    return this.websocket.isConnected;
  }

  /**
   * Manual refresh - fetches events list only (not timing data)
   * Timing data is loaded when navigating to a specific event
   */
  @action
  async refresh() {
    if (this.isRefreshing) return;

    this.isRefreshing = true;
    try {
      const events = await this.cloudAjax.getEvents();
      this.model.events = events.map(event => ({ ...event, eventId: event.id }));
      this.model.lastUpdated = new Date();
    } catch (error) {
      console.error('Error refreshing events list:', error);
    } finally {
      this.isRefreshing = false;
    }
  }

  @action
  manualRefresh() {
    this.refresh();
  }

  @action
  clearWebsocketMessages() {
    this.websocket.clearMessages();
  }

  @action
  logout() {
    this.websocket.disconnect();
    this.auth.logout();
    this.router.transitionTo('login');
  }
}
